/* tslint:disable */
/* eslint-disable */
/**
 * Credit API
 * API for banking integrations
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { JobStatusResponse } from '../model';
/**
 * JobsApi - axios parameter creator
 * @export
 */
export const JobsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deprecated: Use /v1/accounts/connection-status instead TODO: Remove this route after frontend is updated Get the overall status of all jobs and moneytree accounts for the current user.  This endpoint checks the status of: - Credit jobs (fetch and normalization status) - Moneytree bank account aggregation status  Returns SUCCESS only when all credit jobs are successful and all moneytree accounts have successful aggregation state. Returns FAILURE if any job or account has failed status. 
         * @summary Get Job Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobsStatusGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/jobs/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobsApi - functional programming interface
 * @export
 */
export const JobsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JobsApiAxiosParamCreator(configuration)
    return {
        /**
         * Deprecated: Use /v1/accounts/connection-status instead TODO: Remove this route after frontend is updated Get the overall status of all jobs and moneytree accounts for the current user.  This endpoint checks the status of: - Credit jobs (fetch and normalization status) - Moneytree bank account aggregation status  Returns SUCCESS only when all credit jobs are successful and all moneytree accounts have successful aggregation state. Returns FAILURE if any job or account has failed status. 
         * @summary Get Job Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1JobsStatusGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1JobsStatusGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * JobsApi - factory interface
 * @export
 */
export const JobsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JobsApiFp(configuration)
    return {
        /**
         * Deprecated: Use /v1/accounts/connection-status instead TODO: Remove this route after frontend is updated Get the overall status of all jobs and moneytree accounts for the current user.  This endpoint checks the status of: - Credit jobs (fetch and normalization status) - Moneytree bank account aggregation status  Returns SUCCESS only when all credit jobs are successful and all moneytree accounts have successful aggregation state. Returns FAILURE if any job or account has failed status. 
         * @summary Get Job Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobsStatusGet(options?: AxiosRequestConfig): AxiosPromise<JobStatusResponse> {
            return localVarFp.v1JobsStatusGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * JobsApi - object-oriented interface
 * @export
 * @class JobsApi
 * @extends {BaseAPI}
 */
export class JobsApi extends BaseAPI {
    /**
     * Deprecated: Use /v1/accounts/connection-status instead TODO: Remove this route after frontend is updated Get the overall status of all jobs and moneytree accounts for the current user.  This endpoint checks the status of: - Credit jobs (fetch and normalization status) - Moneytree bank account aggregation status  Returns SUCCESS only when all credit jobs are successful and all moneytree accounts have successful aggregation state. Returns FAILURE if any job or account has failed status. 
     * @summary Get Job Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public v1JobsStatusGet(options?: AxiosRequestConfig) {
        return JobsApiFp(this.configuration).v1JobsStatusGet(options).then((request) => request(this.axios, this.basePath));
    }
}
